import { render, staticRenderFns } from "./viewSummarySection.vue?vue&type=template&id=97155ce0"
import script from "./viewSummarySection.vue?vue&type=script&lang=js"
export * from "./viewSummarySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports